document.addEventListener('DOMContentLoaded', () => {
  // ---------------------------------------------------------------------------
  // Navbar scroll behavior
  // ---------------------------------------------------------------------------
  const navbar = document.querySelector('.navbar');

  if (navbar) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ---------------------------------------------------------------------------
  // Mobile menu toggle
  // ---------------------------------------------------------------------------
  const mobileToggle = document.querySelector('.navbar__mobile-toggle');
  const mobileMenu = document.querySelector('.navbar__mobile-menu');

  if (mobileToggle && mobileMenu) {
    const menuIcon = mobileToggle.querySelector('.navbar__menu-icon');
    const closeIcon = mobileToggle.querySelector('.navbar__close-icon');

    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      if (menuIcon) menuIcon.style.display = isOpen ? 'none' : '';
      if (closeIcon) closeIcon.style.display = isOpen ? '' : 'none';
    });

    const mobileLinks = mobileMenu.querySelectorAll('.navbar__mobile-link');
    mobileLinks.forEach((link) => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Scroll animations (IntersectionObserver)
  // ---------------------------------------------------------------------------
  const animatedElements = document.querySelectorAll('.animate-on-scroll');

  if (animatedElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = parseInt(el.dataset.delay, 10) || 0;

          setTimeout(() => {
            el.classList.add('is-visible');
          }, delay);

          observer.unobserve(el);
        }
      });
    }, { threshold: 0.15 });

    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  }
});
